import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { RootMenuItem } from 'src/models/Menu';
import { CurrentUIState } from 'src/models/UIState';
import { SettingsService } from '../../services/settings/settings.service';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CloudServiceEnum } from 'src/app/services/cloud-storage/enums';
import { CloudSettingsService } from 'src/app/services/cloud-settings.service';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentBuilderDirective } from '../../utils/directives/component-builder.directive';
import { MainClickDirectiveDirective } from '../../utils/directives/main-click-directive.directive';
import { ReadAloudDirective } from '../../utils/directives/read-aloud/read-aloud.directive';
import { NgClass, AsyncPipe } from '@angular/common';

@Component({
    selector: 'asg-desktop-menu-item',
    templateUrl: './desktop-menu-item.component.html',
    styleUrls: ['./desktop-menu-item.component.scss'],
    standalone: true,
    imports: [ReadAloudDirective, MainClickDirectiveDirective, NgClass, ComponentBuilderDirective, AsyncPipe, TranslateModule]
})
export class DesktopMenuItemComponent implements AfterViewInit {
  @Input() item: RootMenuItem | null = null;
  @Input() uiState: CurrentUIState & { [key: string]: any } | null = null;
  @Input() isMobile: boolean = false;
  @Output() closeDropdown: EventEmitter<void> = new EventEmitter();
  currentCloudParam: Observable<{ currentCloud: CloudServiceEnum }> = of({ currentCloud: CloudServiceEnum.CloudStorage });
  constructor(private settingsService: SettingsService,
              private cloudSettingsService: CloudSettingsService) { }

  ngAfterViewInit(): void {
    this.currentCloudParam = this.settingsService.getSettingsObservable().pipe(
      map((x) => {
        if (this.cloudSettingsService.isCloudConnected(x.cloudSettings.cloudStorage)) {
          return { currentCloud: x.cloudSettings.cloudStorage }
        } else {
          return { currentCloud: CloudServiceEnum.CloudStorage }
        }
      })
    );
  }

  clicked(): void {
    if (this.item) {
      this.closeDropdown.emit();
    }
  }

}
